import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function jsonValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null; // Não valida se estiver vazio (use Validators.required para isso)
    }

    try {
      JSON.parse(control.value);
      return null; // JSON válido
    } catch (error) {
      return { invalidJson: { message: 'JSON inválido' } };
    }
  };
}
